<template>
  <div class="product-selection-element">
    <ProductSelectionGrid
      :available-products="availableProducts"
      :selection-mode="selectionMode"
      :show-pricing="showPricing"
      :show-images="showImages"
      :model-value="modelValue"
      @update:model-value="handleSelection"
      @selection-confirmed="handleConfirmation"
    />
  </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue';
  import ProductSelectionGrid from '@shared/components/configurator/ProductSelectionGrid.vue';
  import productService from '@shared/services/productService';

  export default {
    name: 'ProductSelectionElement',

    components: {
      ProductSelectionGrid,
    },

    props: {
      element: {
        type: Object,
        required: true,
      },
      modelValue: {
        type: [String, Array],
        default: null,
      },
    },

    emits: ['update:modelValue', 'selection-confirmed'],

    setup(props, { emit }) {
      const loading = ref(true);
      const products = ref([]);

      // Extract settings from element props
      const availableProducts = computed(() => props.element.props?.availableProducts || []);
      const selectionMode = computed(() => props.element.props?.selectionMode || 'single');
      const showPricing = computed(() => props.element.props?.showPricing ?? true);
      const showImages = computed(() => props.element.props?.showImages ?? true);

      const handleSelection = (selectedProductId) => {
        emit('update:modelValue', selectedProductId);
      };

      const handleConfirmation = (selectionData) => {
        emit('selection-confirmed', selectionData);
      };

      return {
        availableProducts,
        selectionMode,
        showPricing,
        showImages,
        handleSelection,
        handleConfirmation,
      };
    },
  };
</script>

<style scoped lang="scss">
  .product-selection-element {
    width: 100%;
  }
</style>
